// extracted by mini-css-extract-plugin
var _1 = "header_copy-top";
var _2 = "header_top-left";
var _3 = "header_top-right";
var _4 = "header_top-wrapper";
export { _1 as "copy-top", _2 as "top-left", _3 as "top-right", _4 as "top-wrapper" }
